import React from 'react';
import { Form } from 'react-bootstrap';
import Plaintext from './plaintext';
import Helpers from 'utils/helpers';
import InputHelpers from 'components/inputs/utils/inputHelpers';
import useInput from 'hooks/input';

export default function TextInputWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    return (
      <Plaintext style={props.style}>
        {Helpers.Object.exists(props.value) ? props.value : props.defaultValue}
      </Plaintext>
    );
  }
  else {
    const clonedProps = { ...props };

    InputHelpers.modifyClonedProps(props, clonedProps);

    return <TextInput {...clonedProps} />;
  }
}

function TextInput(props) {
  const { onChange, onValueChange, onEnterPress, onKeyPress, feedback, help, description, isInvalid, isValid, alwaysShowValidity, autoFocus, ...childProps } = props;
  const { setInputRef, isInputValid, getInputValidityMessage } = useInput({ description, hasCustomError: (props.isInvalid && feedback), customError: feedback, autoFocus: autoFocus });

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  const handleKeyPress = (event) => {
    const code = event.keyCode || event.which;
    if (code === 13 && onEnterPress) {
      onEnterPress();
    }
    if (onKeyPress) {
      onKeyPress(event);
    }
  };

  const renderFeedback = () => {
    if (!isInputValid()) {
      return <div className='invalid-feedback'>{getInputValidityMessage()}</div>;
    }
    else if (props.isInvalid && feedback && !Helpers.String.isEmpty(feedback)) {
      return <div className='invalid-feedback'>{feedback}</div>;
    }
    else if (props.isValid && feedback && !Helpers.String.isEmpty(feedback)) {
      return <div className='valid-feedback'>{feedback}</div>;
    }
    return null;
  };

  const renderHelp = () => {
    if (help && !Helpers.String.isEmpty(help)) {
      return <div className='help-feedback'>{help}</div>;
    }
    return null;
  };

  return (
    <>
      <Form.Control
        {...childProps}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        ref={setInputRef}
        isInvalid={alwaysShowValidity && isInvalid}
        isValid={alwaysShowValidity && isValid}
      />
      {renderHelp()}
      {renderFeedback()}
    </>
  );
}